import { z } from "zod";

export const pathSchema = z.object({
  id: z.number(),
  identifier: z.string(),
  warehouse: z.object({
    id: z.number(),
    name: z.string(),
    status: z.boolean(),
  }),
});

export const pathFormSchema = z.object({
  id: z.number(),
  identifier: z.string(),
  warehouse_id: z.string(),
});

export const warehouseNameSchema = z.object({
  id: z.number(),
  name: z.string(),
});
